<script setup lang="ts">
import type { BreadcrumbProps } from '#seo-utils/app/composables/useBreadcrumbItems'

interface Props extends Pick<BreadcrumbProps, 'overrides'> {
  showBreadcrumbs?: boolean
}

const { overrides, showBreadcrumbs = true } = defineProps<Props>()

setNavigationContext('marketing')

useHead({
  htmlAttrs: {
    class: 'bg-blurple-500',
  },
})
</script>

<template>
  <LayoutContainer>
    <Header />
    <ContentGrid v-if="showBreadcrumbs" class="w-full">
      <Breadcrumbs :overrides="overrides" class="full-width" />
    </ContentGrid>
    <main class="flex-1">
      <slot />
    </main>
    <NettbutikkFooterCta />
    <Footer class="dark-mode" wide />
  </LayoutContainer>
</template>
